import { Component } from '@angular/core';
import {NavController, ViewController} from "ionic-angular";
import {MeetteamProvider} from "../../../../providers/meetteam/meetteam";

/**
 * Generated class for the CreateVisioComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'create-visio',
  templateUrl: 'create-visio.html'
})
export class CreateVisio {

  public localDate: Date = new Date();
  public initDate: Date = new Date();
  public min: Date = new Date();


  meetProps: any = {
    type: 1,
    multiple: false,
    date: null
  };

  createOutput : any = {
    created: false,
    match: false,
    id: '',
    coming: 0,
  };

  constructor(private navCtrl: NavController,
              private viewCtrl: ViewController,
              private meetProvider: MeetteamProvider) {

  }

  goBack() {
    this.viewCtrl.dismiss();
  }


  selectedDateFormat(e){
    this.meetProps.date = e.toLocaleDateString();
  }

  joinLunchRoulette(){
    if (this.meetProps.date == null) return;

    this.meetProvider.create(this.meetProps).subscribe((res) => {
      if(res.success){
        this.createOutput.created = true;
        this.createOutput.match = res.data.full;
        this.createOutput.id = res.data.id;
        this.createOutput.coming = res.data.count;

        this.goBack();
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/employee/lunchroulette/create-visio/create-visio.ts